<template>
<v-container fluid >
 
    <v-layout row style="" class="hidden-xs-only" >
      <v-spacer></v-spacer>
       <v-flex xs12 sm12 lg6 md12>
        <v-text-field
        :style="term!=''?'margin-top: 3px;':''"
        light
        solo
        v-model="term"
        prepend-icon="search"
        :placeholder="gLang[lang].layout.search"
        
      ></v-text-field>
       </v-flex>
    </v-layout>
    <v-layout  row><v-spacer></v-spacer>

       <v-flex xs12 sm12 lg6>
           
      <v-list v-if="term!=''"  three-line class="pa-0"    style="border-radius:5px; border:2px solid #efefef">

         <v-subheader v-if="condition" style="border-bottom:1px solid #efefef" >{{gLang[lang].layout.searchNoResults}}</v-subheader>
          <p class="caption" style="color:black;text-align:center"><v-icon>error_outline</v-icon>{{gLang[lang].layout.searchDisclaimer}}</p>
            <v-subheader v-if="term&&methodResultsArtefacts.length!=0" style="border-bottom:1px solid #efefef" >{{gLang[lang].layout.artefacts}}</v-subheader> 
            <v-list-tile class="listTile"  avatar v-for="(item,index) in methodResultsArtefacts" v-if="index<=1" v-bind:key="item._id" @click="toArtefact(item._id)">



<!-- 
                -->
                          <!-- <v-list-tile-avatar>
                             <img :src="item.mainImg[0].url" alt="">
                            </v-list-tile-avatar>-->
                <v-list-tile-content style="position:relative">
                <!-- <v-list-tile-title v-html="item.title"></v-list-tile-title>
                <v-list-tile-sub-title v-html=" '  <span class=\'grey--text text--lighten-1\'> ' + item.description + '</span>' "> </v-list-tile-sub-title> -->




             <v-layout style="width:100%; position:relative;">
                    <v-flex xs5 class="mb-1 mt-1 pr-2 pl-1" style="border-right:1px solid #efefef" >
                        <v-list-tile-title style=" text-align:right; " v-html="item.title[lang]"></v-list-tile-title>
                    </v-flex>

                    <!-- <v-flex xs1 offset-xs1 style="border-left:1px solid #efefef">

                    </v-flex> -->

                    <v-flex xs7 class="mb-1 mt-1 pl-2 pr-1" style="border-left:1px solid #efefef; overflow:hidden; position:relative" >
                          <v-list-tile-sub-title style="height:80%" class="" v-html=" '  <span class=\'grey--text text--lighten-1\'> ' + item.description[lang] + '</span>' "> </v-list-tile-sub-title>
                    </v-flex>
                </v-layout>

              </v-list-tile-content> 
            </v-list-tile>


                      <v-subheader v-if="term&&methodResultsCollections.length!=0" style="border-bottom:1px solid #efefef" >{{gLang[lang].layout.collections}}</v-subheader> 
            <v-list-tile class="listTile"  avatar v-for="(item,index) in methodResultsCollections" v-if="index<=1" v-bind:key="item._id" @click="toCollection(item._id)">



<!-- 
                -->
                          <!-- <v-list-tile-avatar>
                             <img :src="item.mainImg[0].url" alt="">
                            </v-list-tile-avatar>-->
                <v-list-tile-content style="position:relative">
                <!-- <v-list-tile-title v-html="item.title"></v-list-tile-title>
                <v-list-tile-sub-title v-html=" '  <span class=\'grey--text text--lighten-1\'> ' + item.description + '</span>' "> </v-list-tile-sub-title> -->




             <v-layout style="width:100%; position:relative;">
                    <v-flex xs5 class="mb-1 mt-1 pr-2 pl-1" style="border-right:1px solid #efefef" >
                        <v-list-tile-title style=" text-align:right; " v-html="item.title[lang]"></v-list-tile-title>
                    </v-flex>

                    <!-- <v-flex xs1 offset-xs1 style="border-left:1px solid #efefef">

                    </v-flex> -->

                    <v-flex xs7 class="mb-1 mt-1 pl-2 pr-1" style="border-left:1px solid #efefef; overflow:hidden; position:relative" >
                          <v-list-tile-sub-title style="height:80%" class="" v-html=" '  <span class=\'grey--text text--lighten-1\'> ' + item.description[lang] + '</span>' "> </v-list-tile-sub-title>
                    </v-flex>
                </v-layout>

              </v-list-tile-content> 
            </v-list-tile>




                      <v-subheader v-if="term&&methodResultsGroups.length!=0" style="border-bottom:1px solid #efefef" >{{gLang[lang].layout.groups}}</v-subheader> 
            <v-list-tile class="listTile"  avatar v-for="(item,index) in methodResultsGroups" v-if="index<=1" v-bind:key="item._id" @click="toGroup(item._id)">



<!-- 
                -->
                          <!-- <v-list-tile-avatar>
                             <img :src="item.mainImg[0].url" alt="">
                            </v-list-tile-avatar>-->
                <v-list-tile-content style="position:relative">
                <!-- <v-list-tile-title v-html="item.title"></v-list-tile-title>
                <v-list-tile-sub-title v-html=" '  <span class=\'grey--text text--lighten-1\'> ' + item.description + '</span>' "> </v-list-tile-sub-title> -->




             <v-layout style="width:100%; position:relative;">
                    <v-flex xs5 class="mb-1 mt-1 pr-2 pl-1" style="border-right:1px solid #efefef" >
                        <v-list-tile-title style=" text-align:right; " v-html="item.title[lang]"></v-list-tile-title>
                    </v-flex>

                    <!-- <v-flex xs1 offset-xs1 style="border-left:1px solid #efefef">

                    </v-flex> -->

                    <v-flex xs7 class="mb-1 mt-1 pl-2 pr-1" style="border-left:1px solid #efefef; overflow:hidden; position:relative" >
                          <v-list-tile-sub-title style="height:80%" class="" v-html=" '  <span class=\'grey--text text--lighten-1\'> ' + item.description[lang] + '</span>' "> </v-list-tile-sub-title>
                    </v-flex>
                </v-layout>

              </v-list-tile-content> 
            </v-list-tile>

          

          </v-list>


<!-- 
           <v-list two-line>
          <template >

              <div  v-for="(item,index) in methodResults"  v-bind:key="index"  v-if="index<=0" >
                      <v-subheader></v-subheader>
            <v-divider ></v-divider>
            <v-list-tile avatar v-bind:key="item.title"  >
              <v-list-tile-avatar>
                             <img :src="item.mainImg[0].url" alt="">
                            </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title v-html="item.title"></v-list-tile-title>
                <v-list-tile-sub-title v-html=" '  <span class=\'grey--text text--lighten-1\'> ' + item.description + '</span>' "> </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
              </div>
        
          </template>
        </v-list> -->
         
          </v-flex>
          </v-layout>
  </v-container>
</template>

<script>
export default {
  props:['term'],
  data() {
    return {
      //term: "",
      index: 0,
      options: {
      ro: {
        keys: ["title.ro" ,"description.ro"],
        includeMatches: true
      },
      en: {
        keys: ["title.en" ,"description.en"],
        includeMatches: true
      },
      sr: {
        keys: ["title.sr" ,"description.sr"],
        includeMatches: true
      },
      },
      methodResultsArtefacts: [],
      methodResultsGroups: [],
      methodResultsCollections: []
    };
  },
  computed: {
    lang() {
      return this.$store.getters.loadLang
    },
    condition() {
      return (
        this.methodResultsGroups.length == 0 &&
        this.methodResultsCollections.length == 0 &&
        this.methodResultsArtefacts.length == 0
      );
    },
    artefacts() {
      return this.$store.getters.loadArtefacts;
    },
    groups() {
      return this.$store.getters.loadGroups;
    },
    collections() {
      return this.$store.getters.loadAllCollections;
    }
  },
  methods: {
    max(array) 
    {
      array.sort(function(a,b){
        return (-(a[1]-a[0])+(b[1]-b[0]))
      })
      return array[0];
    },
    highlighter(object, match) {
      for (var mat of match) {
        var i = this.max(mat.indices);
        var keys = mat.key.split('.');
          object[keys[0]][keys[1]] =
            object[keys[0]][keys[1]].substr(0, i[0]) +
            "<b>" +
            object[keys[0]][keys[1]].substr(i[0], i[1] - i[0] + 1) +
            "</b>" +
            object[keys[0]][keys[1]].substr(i[1] + 1);
      }
      return object;
    },

    toArtefact(artefactID) {
      this.$router.push("/artefacts/" + artefactID);
      this.$emit('success');
    },
    toGroup(groupID) {
      this.$router.push("/groups/" + groupID);
      this.$emit('success');
    },
    toCollection(collectionID) {
      this.$router.push("/collections/" + collectionID);
      this.$emit('success');
    }
  },
  mounted() {
    this.term = "";
    window.scrollTo(0, 0);
    this.$store.dispatch("loadArtefacts");
    this.$store.dispatch("loadGroups");
  },

  watch: {
    term() {
      this.$search(this.term, this.artefacts, this.options[this.lang]).then(results => {
        this.methodResultsArtefacts = JSON.parse(JSON.stringify(results));
        this.methodResultsArtefacts = this.methodResultsArtefacts.map(x =>
          this.highlighter(x.item, x.matches)
        );
      });
      this.$search(this.term, this.groups, this.options[this.lang]).then(results => {
         this.methodResultsGroups = JSON.parse(JSON.stringify(results));
        this.methodResultsGroups = this.methodResultsGroups.map(x =>
          this.highlighter(x.item, x.matches));
      });
      this.$search(this.term, this.collections, this.options[this.lang]).then(results => {
         this.methodResultsCollections = JSON.parse(JSON.stringify(results));
        this.methodResultsCollections = this.methodResultsCollections.map(x =>
          this.highlighter(x.item, x.matches));
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Partials/SearchGlobal.vue